/**
 * Copyright IBM Corp. 2022, 2026
 */

import classNames from 'classnames'
import { Text } from '@hashicorp/mds-react/components'
import { ProductLogo } from 'components/materia/product-logo'
import s from './style.module.css'

type Eyebrow =
	| { __typename: 'EyebrowTextRecord'; text: string }
	| {
			__typename: 'ProductLogoRecord'
			product: string
			size?: string | null
			color?: string | null
	  }
interface ModularEyebrowProps {
	eyebrow: Eyebrow
	className?: string
}

const ModularEyebrow = ({ eyebrow, className }: ModularEyebrowProps) => {
	return (
		<div className={classNames(s.eyebrowWrapper, className)}>
			{eyebrow && <ModularEyebrowContent eyebrow={eyebrow} />}
		</div>
	)
}

const ModularEyebrowContent = ({ eyebrow }: { eyebrow: Eyebrow }) => {
	switch (eyebrow.__typename) {
		case 'EyebrowTextRecord':
			return (
				<Text.Label color="faint" weight="semibold">
					{eyebrow.text}
				</Text.Label>
			)
		case 'ProductLogoRecord':
			return <ProductLogo {...eyebrow} />
		default:
			return null
	}
}

export default ModularEyebrow
